import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { CronEditorComponent } from './cron-editor/cron-editor.component';
import { TimePickerComponent } from './time-picker/time-picker.component';

// Custom date format for dd/mm/yyyy
export const DD_MM_YYYY_FORMAT = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [CronEditorComponent, TimePickerComponent],
    imports: [CommonModule, FormsModule, MatDatepickerModule, MatInputModule, MatNativeDateModule],
    exports: [CronEditorComponent],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // en-GB uses day/month/year format
    ],
})
export class CronEditorModule {}
